import {Component, Inject, OnInit} from '@angular/core';
import { MatSnackBarRef, MatSnackBarModule } from '@angular/material/snack-bar';
import { ISnackBarAction, ISnackBarConfig } from '../../services/snack-bar.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-ph-snack-bar',
    templateUrl: './ph-snack-bar.component.html',
    styleUrls: ['./ph-snack-bar.component.scss'],
	imports: [CommonModule, TranslateModule, MatSnackBarModule],
    standalone: true
})
export class PhSnackBarComponent implements OnInit {
	config: ISnackBarConfig;

	constructor(@Inject(MatSnackBarRef) private snackBarRef: any) {}

	ngOnInit(): void {
		this.config = this.snackBarRef.containerInstance.snackBarConfig.data;
	}

	dismiss(): void {
		this.snackBarRef.dismiss();
	}

	dismissWithAction(action: ISnackBarAction): void {
		action.callback();
		this.snackBarRef.dismiss();
	}
}
